import styled from '@emotion/styled';
import React, { ReactNode } from 'react';
import DotLoader from '../dotLoader/DotLoader';
import { useTranslation } from 'react-i18next';

const LoadingMessage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  margin: 4rem 3rem;

  & h2,
  & h3 {
    margin: 0;
    text-align: center;
  }
`;

interface IProps {
  message: string;
  submessage?: ReactNode;
  headerMessage?: string;
}

const LongLoader: React.FC<IProps> = ({ message, submessage, headerMessage }) => {
  const { t } = useTranslation();
  const defaultSubmessage = (
    <>
      {t(($) => $.componentLongLoader.takeAFewSeconds)} <strong>{t(($) => $.componentLongLoader.dontCloseWindow)}</strong>
    </>
  );
  return (
    <LoadingMessage>
      {headerMessage && <h6>{headerMessage}</h6>}
      <DotLoader />
      <h2>{message}</h2>
      <h6 style={{ textAlign: 'center' }}>{!!submessage ? submessage : defaultSubmessage}</h6>
    </LoadingMessage>
  );
};

export default LongLoader;
